import { render } from "./OneclickBookingFunction.vue?vue&type=template&id=1330670a&scoped=true"
import script from "./OneclickBookingFunction.vue?vue&type=script&lang=js"
export * from "./OneclickBookingFunction.vue?vue&type=script&lang=js"

import "./OneclickBookingFunction.vue?vue&type=style&index=0&id=1330670a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1330670a"]])

export default __exports__